// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__oukud","content":"ManualTimeModal_content__1lGk4"};